{
  "notifications.title": "通知",
  "notifications.centerTitle": "通知中心",
  "notifications.pageDescription": "集中查看工单分配、提及和重要状态变化。",
  "notifications.openCenter": "打开通知中心",
  "notifications.listLabel": "通知列表",
  "notifications.unreadCount": "通知，{count} 条未读",
  "notifications.new": "有新消息",
  "notifications.dismissPreview": "收起通知预览",
  "notifications.all": "全部",
  "notifications.unread": "未读",
  "notifications.unreadShort": "{count} 条未读",
  "notifications.today": "今天",
  "notifications.earlier": "更早",
  "notifications.menu.label": "通知视图",
  "notifications.menu.filter": "过滤",
  "notifications.menu.assignedToMe": "分配给我",
  "notifications.menu.mentionedMe": "提及我",
  "notifications.menu.participating": "参与通知",
  "notifications.menu.system": "系统通知",
  "notifications.menu.settings": "通知设置",
  "notifications.menu.comingSoon": "即将开放",
  "notifications.preferences.description": "管理通知送达你的方式。",
  "notifications.preferences.deliveryTitle": "接收方式",
  "notifications.preferences.deliveryDescription": "站内通知会始终保留，浏览器通知则按设备分别管理。",
  "notifications.preferences.inAppTitle": "站内通知",
  "notifications.preferences.inAppDescription": "工单分配、提及和重要更新会显示在通知中心。",
  "notifications.preferences.alwaysOn": "始终开启",
  "notifications.loading": "正在加载通知…",
  "notifications.loadFailed": "通知加载失败",
  "notifications.retry": "重试",
  "notifications.emptyAll": "还没有通知",
  "notifications.emptyUnread": "通知都已读完",
  "notifications.emptyAllDetail": "工单指派、提及等消息会显示在这里",
  "notifications.emptyUnreadDetail": "新的未读通知会显示在这里",
  "notifications.markAllRead": "全部标为已读",
  "notifications.markingAllRead": "正在标记全部已读",
  "notifications.markAllReadSuccess": "已将现有通知全部标为已读",
  "notifications.loadMore": "查看更多",
  "notifications.loadingMore": "正在加载更多通知",
  "notifications.relatedUnavailable": "相关内容已无法访问",
  "notifications.viewDetails": "查看详情",
  "notifications.category.ticket": "工单",
  "notifications.category.system": "系统",
  "notifications.category.default": "通知",
  "notifications.ticketAssigned": "工单 {number} 已分配给你",
  "notifications.ticketAssignedGeneric": "有一张工单已分配给你",
  "notifications.ticketMentioned": "有人在工单 {number} 中提及了你",
  "notifications.ticketMentionedGeneric": "有人在工单中提及了你",
  "notifications.ticketParticipantAdded": "你已成为工单 {number} 的协作者",
  "notifications.ticketParticipantAddedGeneric": "你已成为一张工单的协作者",
  "notifications.ticketReopened": "工单 {number} 已重新打开",
  "notifications.ticketReopenedGeneric": "有一张工单已重新打开",
  "notifications.push.title": "浏览器通知",
  "notifications.push.loading": "正在检查此设备…",
  "notifications.push.statusOn": "已开启",
  "notifications.push.statusOff": "已关闭",
  "notifications.push.enabledDescription": "Tickbird 在后台时也能显示工单提醒。",
  "notifications.push.disabledDescription": "开启后，Tickbird 在后台时也能收到工单提醒。",
  "notifications.push.enable": "开启",
  "notifications.push.onboardingTitle": "及时收到重要通知",
  "notifications.push.onboardingDescription": "开启桌面通知后，离开页面也能收到工单分配、提及和重要状态变化。",
  "notifications.push.onboardingEnable": "开启通知",
  "notifications.push.later": "以后再说",
  "notifications.push.enabling": "正在开启…",
  "notifications.push.enablingDescription": "正在请求浏览器权限并注册此设备。",
  "notifications.push.disable": "关闭",
  "notifications.push.disabling": "正在关闭…",
  "notifications.push.errorTitle": "无法更新浏览器通知",
  "notifications.push.errorDescription": "请检查网络连接后重试。",
  "notifications.push.retry": "重试浏览器通知",
  "notifications.push.deniedTitle": "浏览器通知已被阻止",
  "notifications.push.deniedDescription": "请在浏览器设置中允许此网站发送通知，然后重试。",
  "notifications.push.serverDisabledTitle": "浏览器通知暂不可用",
  "notifications.push.serverDisabledDescription": "当前 Tickbird 服务器尚未配置 Web Push。",
  "notifications.push.unsupportedTitle": "此设备不支持浏览器通知",
  "notifications.push.unsupportedDescription": "请使用支持 Web Push 的浏览器和安全连接。",
  "notifications.push.enabledSuccess": "已在此设备上开启浏览器通知。",
  "notifications.push.disabledSuccess": "已在此设备上关闭浏览器通知。",
  "notifications.push.disabledLocalOnly": "已在本地关闭通知，但暂时无法连接服务器。",
  "notifications.push.updateFailed": "无法更新浏览器通知。"
}
